/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SiMicrosoftoffice } from "react-icons/si";
import { FaKey } from "react-icons/fa";
import { useNavigate } from "react-router";
import Resources from "src/config/Resources";
import CustomSharedButton from "src/shared/CustomSharedButton";
import { useMediaQuery } from "react-responsive";
// eslint-disable-next-line import/no-extraneous-dependencies
import { PublicClientApplication, AuthenticationResult } from "@azure/msal-browser";
import StorageService from "src/utils/Storage/storageService";
import store from "src/redux/store";
import { SET_TOAST_ERROR, setUserData, setOtpVerificationDetails } from "src/redux/Actions/common";
import loginCall, {
  constructSAMLUri,
  resentLoginOtp,
  samlLoginGetUser,
  sendLoginOtpCall,
  verifyLoginOtp
} from "src/services/Login";
import { useMutation } from "react-query";
import { IRM_CLIENT_ID, IRM_TENANT_ID } from "src/config/constant";
import CustomSelect from "src/shared/CustomSelect";
import { useFormik } from "formik";
import * as yup from "yup";
import CustomBackDrop from "src/shared/CustomBackDrop";
import CustomTextField from "src/shared/CustomTextField";
import {
  Partner,
  partnerCodes,
  samlPartnerIncludes,
  setLoggedInUserData,
  signInMessage
} from "src/helpers/Auth";
import { useCookies, CookiesProvider } from "react-cookie";
import CustomLogoutAll from "src/shared/CustomLogoutAll";
import logoutCall from "src/services/Logout";
import CustomOTPModal from "src/shared/CustomOtpModal";
import { useAppSelector } from "src/utils/hooks/useAppSelector";

function Landing() {
  const { otpVerificationId } = useAppSelector((state) => state.otpVerificationDetails || {});
  const SREI_PARTNER_CODE = partnerCodes["SREI INSURANCE BROKING PRIVATE LIMITED"];
  const authConfig = {
    auth: {
      clientId: IRM_CLIENT_ID,
      authority: `https://login.microsoftonline.com/${IRM_TENANT_ID}`,
      redirectUri: "/"
    }
  };
  const msalInstance = new PublicClientApplication(authConfig);
  const [searchParams] = useSearchParams();
  const [cookie] = useCookies(["token"]);
  const navigate = useNavigate();
  // const leadQuery = searchParams.get("leadId");
  // const [isLoggingIn, setIsLoggingIn] = useState(false);
  // const [fetchLeadInfo, setFetchLeadInfo] = useState(false);
  // const queryClient = useQueryClient();
  const [openCustomLogoutAll, setOpenCustomLogoutAll] = useState(false);
  const [isFormOpen, setIsOpenForm] = useState(false);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 700 });
  const { mutate, isLoading } = useMutation(["login"], loginCall, {
    retry: false,
    onSuccess: async (response: any) => {
      await setLoggedInUserData(response);
      const redirectTo = searchParams.get("redirectTo");
      if (redirectTo) {
        navigate(redirectTo);
      } else {
        navigate("/dashboard");
      }
    },
    onError: async (response: any) => {
      if (response?.data?.userId) {
        StorageService.setInLocalStorage("userId", response?.data?.userId);
        setOpenCustomLogoutAll(false);
      } else {
        console.error("Login error:", response);
      }
    }
  });

  const { mutate: sendOtp, isLoading: isOtpSending } = useMutation(sendLoginOtpCall, {
    onSuccess: (response: any) => {
      if (response?.data?.id) {
        store.dispatch(setOtpVerificationDetails({ otpVerificationId: response?.data?.id }));
      }
      setIsOtpModalOpen(true);
    },
    onError: (err: any) => {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          message: err?.message || "Failed to send OTP"
        })
      );
    }
  });

  const { mutate: verifyOtpMutation } = useMutation(verifyLoginOtp, {
    onSuccess: async (response: any) => {
      await setLoggedInUserData(response);
      const redirectTo = searchParams.get("redirectTo");
      if (redirectTo) {
        navigate(redirectTo);
      } else {
        navigate("/dashboard");
      }
    },
    onError: () => {
      store.dispatch(setOtpVerificationDetails({ otpValue: "" }));
    }
  });

  const handleVerifyOTP = ({ id: verificationId, otp }: { id: string; otp: string }) => {
    verifyOtpMutation({ id: verificationId, otp });
  };

  const { mutate: logoutAPI } = useMutation(["logout"], logoutCall, {
    retry: false,
    onSettled: () => {
      navigate("/");
    }
  });

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    initialValues: {
      roleType: "AFLI",
      email: "",
      password: ""
    },
    validationSchema: yup.object().shape({
      roleType: yup.string(),
      email: yup.string().required("Required"),
      password: yup.string().when("roleType", {
        is: (val: string) => partnerCodes[val as keyof Partner] !== SREI_PARTNER_CODE,
        then: (schema) => schema.required("Required"),
        otherwise: (schema) => schema.notRequired()
      })
    }),
    onSubmit: ({ email, password, roleType }) => {
      if (partnerCodes[roleType as keyof Partner] === SREI_PARTNER_CODE) {
        sendOtp({
          sendTo: email,
          length: 4,
          partnerCode: SREI_PARTNER_CODE
        });
        return;
      }
      mutate({ email, password });
    }
  });

  const { mutate: mutateSAMLLogin, isLoading: isSAMLLoginLoading } = useMutation(samlLoginGetUser, {
    onSuccess: async (response) => {
      await setLoggedInUserData(response.data);
      navigate("/dashboard");
    },
    onError: () => {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          message: "Failed to Sign In"
        })
      );
    }
  });

  const handleSAMLLogin = () => {
    console.log("cookie", cookie);
    const token = searchParams.get("token");
    console.log("token", token);
    if (token) {
      StorageService.setInLocalStorage("samlToken", token);
      mutateSAMLLogin();
    }
  };

  useEffect(() => {
    handleSAMLLogin();
  }, []);

  useEffect(() => {
    setIsOpenForm(partnerCodes[formik.values.roleType as keyof Partner] === SREI_PARTNER_CODE);
  }, [formik.values.roleType]);

  const postLogin = (loginResponse: AuthenticationResult) => {
    StorageService.setInLocalStorage("token", {
      idToken: loginResponse.idToken
    });
    store.dispatch(setUserData(loginResponse.account));
    mutate({});
  };
  const { mutate: mutateMsalLogin, isLoading: isADLoginLoading } = useMutation(
    () => msalInstance.loginPopup(),
    {
      onSuccess: (response) => {
        postLogin(response);
      },
      onError: () => {
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            message: "Failed to Sign In"
          })
        );
      }
    }
  );
  const handleIRMADLogin = async () => {
    try {
      if (samlPartnerIncludes.includes(partnerCodes[formik?.values?.roleType as keyof Partner])) {
        window.open(
          constructSAMLUri(partnerCodes[formik?.values?.roleType as keyof Partner]!),
          "_self"
        );
      } else {
        await msalInstance.initialize();
        mutateMsalLogin();
      }
    } catch (error) {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          message: "Failed to Sign In"
        })
      );
    }
  };
  function handleSubmitIfNoErrors() {
    const userId = StorageService.getFromLocalStorage("userId");
    if (userId) logoutAPI(userId);
    setOpenCustomLogoutAll(false);
  }

  return (
    <CookiesProvider>
      {isOtpModalOpen && (
        <CustomOTPModal
          isModal={isOtpModalOpen}
          setIsOtpModalOpen={setIsOtpModalOpen}
          onClose={() => setIsOtpModalOpen(false)}
          onResendClick={() => {
            if (otpVerificationId) {
              resentLoginOtp({ id: otpVerificationId });
              store.dispatch(
                SET_TOAST_ERROR({
                  error: true,
                  type: "success",
                  message: "OTP sent again."
                })
              );
            } else {
              store.dispatch(
                SET_TOAST_ERROR({
                  error: true,
                  message: "OTP ID not found, please try sending OTP again."
                })
              );
            }
          }}
          onVerify={handleVerifyOTP}
          showCancelButton={false}
          modalHeading="Please enter the OTP sent on your email address"
          timerMinutes={1.5}
        />
      )}
      {openCustomLogoutAll && (
        <CustomLogoutAll
          text={
            <div>
              <p>User already logged in.</p>
              <p>Do you want to logout from all devices?</p>
            </div>
          }
          onNext={() => handleSubmitIfNoErrors()}
          onCancel={() => setOpenCustomLogoutAll(false)}
        />
      )}
      <CustomBackDrop open={isLoading || isADLoginLoading || isSAMLLoginLoading || isOtpSending} />
      <div className="flex flex-col md:flex-row items-center justify-center h-screen md:gap-40 gap-10">
        <img
          className="w-4/5 md:w-[17vw] mb-[2vh]"
          src={Resources.images.Header.afliHero}
          alt="AFLI Logo"
        />
        <div className="hidden md:block border-r-1.5 border-blueBerryWhip h-[15vh]" />
        <section className={`${isMobile ? "w-full" : ""}`}>
          <div className="w-4/5 md:w-[27vw] flex flex-col items-center justify-center mx-auto md:h-screen ">
            <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
              <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                <CustomSelect
                  requiredStar
                  label="Select Role"
                  className=""
                  options={Object.keys(partnerCodes)}
                  onChange={formik.handleChange}
                  setFieldTouched={formik.setFieldTouched}
                  name="roleType"
                  value={formik.values.roleType}
                  error={formik.errors.roleType}
                  touched={formik.touched.roleType}
                />
                <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
                  Sign in to your account
                </h1>
                {/* //TODO:Integrate AD */}
                {!isFormOpen && (
                  <>
                    <CustomSharedButton
                      className="w-full flex border-gray-300 border-1.5"
                      type="button"
                      ButtonIcon={
                        partnerCodes?.[formik.values.roleType as keyof Partner] !== "federal"
                          ? SiMicrosoftoffice
                          : FaKey
                      }
                      // onClick={handleADLogin}
                      onClick={() => handleIRMADLogin()}
                      text={signInMessage?.[formik.values.roleType]}
                      // isLoading={postLoginLoading}
                    />
                    <div className="w-full text-xs gap-4 text-gray-500 text-center">
                      {/* <span className="border-t-[1.5px] border-[#d1d5db] w-full " /> */}
                      <p>Can&apos;t login through Microsoft?</p>
                      <p>
                        <button
                          className="text-megaMan hover:underline cursor-pointer"
                          onClick={() => setIsOpenForm(true)}
                          type="button"
                        >
                          Click here
                        </button>{" "}
                        to login manually
                      </p>
                      {/* <span className="border-t-[1.5px] border-[#d1d5db] w-1/3" /> */}
                    </div>
                  </>
                )}
                {isFormOpen && (
                  <form className="space-y-4 md:space-y-3" onSubmit={formik.handleSubmit}>
                    {/* <div> */}
                    {/* <label
                        htmlFor="email"
                        className="block mb-2 text-sm font-medium text-gray-900">
                        Your email
                      </label> */}
                    {/* <input
                        type="email"
                        name="email"
                        id="email"
                        className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                        // onChange={handleChange}
                      /> */}
                    <CustomTextField
                      label="Email"
                      onChange={formik.handleChange}
                      handleBlur={formik.handleBlur}
                      value={formik.values.email}
                      name="email"
                      error={formik.errors.email}
                      touched={formik.touched.email}
                    />
                    {partnerCodes[formik.values.roleType as keyof Partner] !==
                      SREI_PARTNER_CODE && (
                      <CustomTextField
                        requiredStar
                        label="Password"
                        onChange={formik.handleChange}
                        handleBlur={formik.handleBlur}
                        value={formik.values.password}
                        name="password"
                        error={formik.errors.password}
                        touched={formik.touched.password}
                      />
                    )}
                    <CustomSharedButton
                      className="w-full text-white bg-ritaRepulsa"
                      type="submit"
                      text={
                        partnerCodes[formik.values.roleType as keyof Partner] !== SREI_PARTNER_CODE
                          ? "Sign in"
                          : "Authenticate via OTP"
                      }
                      // isLoading={isLoading}
                    />
                    {partnerCodes[formik.values.roleType as keyof Partner] !==
                      SREI_PARTNER_CODE && (
                      <button
                        className="text-megaMan text-xs hover:underline cursor-pointer"
                        onClick={() => setIsOpenForm(false)}
                        type="button"
                      >
                        Back to Microsoft login
                      </button>
                    )}
                  </form>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </CookiesProvider>
  );
}

export default Landing;
